import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ConsentService } from '../consent.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-consent-banner',
    templateUrl: './consent-banner.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatButton, TranslateModule],
})
export class ConsentBannerComponent {
  constructor(private consentService: ConsentService) {
  }

  /**
   * sets GDPR cookie value and updates value in store
   */
  acceptCookies() {
    this.consentService.updateConsent({
      consents: {
        essential: true,
        analytics: true,
      },
    });
  }

  /**
   * sets GDPR cookie value and updates value in store
   */
  rejectCookies() {
    this.consentService.updateConsent({
      consents: {
        essential: true,
        analytics: false,
      },
    });
  }

  /**
   * Opens popup
   */
  manageCookies() {
    this.consentService.openPopup();
  }
}
